const LIMIT = 4;
class ComparisonForm {
  constructor() {
    if ($('.algolia-listing-pages').length) {
      return;
    }
    // Set up tray with any checkboxes already checked
    this.turboBeforeCache = this.turboBeforeCache.bind(this);
    this.reConstructor = this.reConstructor.bind(this);
    this.stopCardLinkClick = this.stopCardLinkClick.bind(this);
    this.handleCardToggleProduct = this.handleCardToggleProduct.bind(this);
    this.handleTrayRemoveProduct = this.handleTrayRemoveProduct.bind(this);
    this.handleClearTray = this.handleClearTray.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectedProducts =
      ProductCatalog.LocalStorage.read('product_comparision') || [];
    this.setInitialState();
    $(document).on('click', '.pc-ProductCard-compare', this.stopCardLinkClick);
    // Bind card compare checkbox to add/remove products in tray
    $(document).on(
      'change',
      ".pc-ProductCard-compare input[type='checkbox']",
      this.handleCardToggleProduct
    );
    // Bind closer to remove individual tray items
    $(document).on(
      'click',
      '.pc-ComparisonForm-item-closer',
      this.handleTrayRemoveProduct
    );
    // Bind compare screen closer to remove individual tray items
    $(document).on('removeItem.compare', this.handleTrayRemoveProduct);
    // Bind clear link to remove all tray items
    $(document).on('click', '.pc-ComparisonForm-clear', this.handleClearTray);
    // Bind submit button to show the comparison modal
    $(document).on('click', '.pc-ComparisonForm-submit', this.handleSubmit);

    document.addEventListener('turbolinks:before-cache', this.turboBeforeCache);
  }

  turboBeforeCache() {
    return $.magnificPopup.close();
  }

  reConstructor() {
    // Set up tray with any checkboxes already checked
    return this.setInitialState();
  }

  stopCardLinkClick(e) {
    return e.stopPropagation();
  }

  setInitialState() {
    if (this.selectedProducts.length > 0) {
      this.rebuildTray();
      return this.tray().addClass('is-active');
    }
  }

  tray() {
    return $('.pc-ComparisonForm');
  }

  traySlots() {
    return this.tray().find('.pc-ComparisonForm-item');
  }

  trayCards() {
    return this.selectedProductIds().reduce(function (memo, id) {
      memo.push($(`.pc-ProductCard[data-style-id='${id}']`));
      return memo;
    }, []);
  }

  productName($card) {
    return $card.find("[itemprop='name']").first().text();
  }

  addToTray(id) {
    let needle;
    const $root = this.tray().addClass('is-active');
    const $form = $root.find('.pc-ComparisonForm-form');
    const $inputs = $form.find("input[name='ids[]']");
    if (this.selectedProducts.length >= LIMIT) {
      return false;
    }
    if (
      ((needle = id.toString()),
      Array.from(this.selectedProductIds()).includes(needle))
    ) {
      return false;
    }
    this.addToSelectedProducts(id);
    this.rebuildTray();
    CustomInk.Metrics.fireEvent(
      'compare products',
      'select',
      `for select ${$inputs.length + 1}`
    );
    return true;
  }

  removeFromTray(id) {
    this.removeFromSelectedProducts(id);
    const $card = $(`.pc-ProductCard[data-style-id='${id}']`);
    if ($card.length > 0) {
      $card.find(
        ".pc-ProductCard-compare input[type='checkbox']"
      )[0].checked = false;
    }
    return this.rebuildTray();
  }

  ensureActiveCardsChecked(cards) {
    return cards.forEach(function (element) {
      if (element.length > 0) {
        return (element.find(
          ".pc-ProductCard-compare input[type='checkbox']"
        )[0].checked = true);
      }
    });
  }

  rebuildTray() {
    const $cards = this.trayCards();
    const $slots = this.traySlots();
    this.ensureActiveCardsChecked($cards);
    if ($cards.length === 0) {
      this.tray().removeClass('is-active');
    }
    if ($cards.length > 1) {
      this.showButtons();
    } else {
      this.showAddMore();
    }
    Array.from($slots).forEach((slot, idx) => {
      const $product = this.selectedProducts[idx];
      const $slot = $(slot);
      this.setSlot($slot, $product);
    });
  }

  // Private: Event Handlers

  handleCardToggleProduct(evt) {
    const id = $(evt.target).parents('.pc-ProductCard').data('style-id');
    if (evt.target.checked) {
      const filled = this.addToTray(id);
      if (!filled) {
        evt.target.checked = false;
        evt.preventDefault();
        return evt.stopPropagation();
      }
    } else {
      this.removeFromTray(id);
      return CustomInk.Metrics.fireEvent(
        'compare products',
        'deselect',
        'card'
      );
    }
  }

  handleTrayRemoveProduct(evt, id) {
    // Bind closer for individual tray items
    evt.preventDefault();
    if (!id) {
      id = $(evt.target).parent().data('style-id');
    }
    this.removeFromTray(id);
    return CustomInk.Metrics.fireEvent('compare products', 'deselect', 'tray');
  }

  handleClearTray(evt) {
    if (evt != null) {
      evt.preventDefault();
    }
    this.selectedProductIds().forEach(this.removeFromTray.bind(this));
    if (evt != null) {
      return CustomInk.Metrics.fireEvent(
        'compare products',
        'clear all',
        'tray'
      );
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const $form = $(evt.target).closest('form');
    const qty = $("meta[property='category-default-quote-qty']").attr(
      'content'
    );
    let url = `/products/styles/compare?ids[]=${this.selectedProductIds().join(
      '&ids[]='
    )}`;
    if (qty) {
      url += `&qty=${qty}`;
    }
    $.magnificPopup.open({
      items: {
        src: url
      },
      type: 'ajax',
      alignTop: true,
      closeBtnInside: false,
      closeMarkup: this.modalCloseButtonMarkup(),
      overflowY: 'hidden',
      mainClass: 'pc-Modal pc-ComparisonModal',
      removalDelay: 0,
      callbacks: {
        ajaxContentAdded() {
          let containerSelector;
          return (containerSelector =
            '.pc-ComparisonModal.mfp-wrap .mfp-container');
        }
      }
    });
    return CustomInk.Metrics.fireEvent(
      'compare products',
      'compare products',
      'tray'
    );
  }

  // Private: Dom Modifiers

  clearSlot($slot) {
    return $slot.empty().removeClass('is-active').data('style-id', undefined);
  }

  setSlot($slot, $product) {
    this.clearSlot($slot);
    if (!($slot.length > 0) || !$product) {
      return;
    }
    return $slot
      .addClass('is-active')
      .append(this.productCloserFactory())
      .append(this.productImageFactory($product))
      .append(this.productDescriptionFactory($product))
      .data('style-id', $product.id);
  }

  showButtons() {
    this.tray().find('.pc-ComparisonForm-addMore').removeClass('is-active');
    return this.tray().find('.pc-ComparisonForm-buttons').addClass('is-active');
  }

  showAddMore() {
    this.tray().find('.pc-ComparisonForm-buttons').removeClass('is-active');
    return this.tray().find('.pc-ComparisonForm-addMore').addClass('is-active');
  }

  // Private: Element Factories

  modalCloseButtonMarkup() {
    return '<span class="sb-Icon--close mfp-close"></span>';
  }

  productImageFactory($product) {
    return $(`<img class='pc-ComparisonForm-item-image' \
                src='${$product.productImgSrc}' \
                alt='${$product.productDescription}' />`);
  }

  productCloserFactory() {
    return $("<a class='pc-ComparisonForm-item-closer' href='#'>×</a>");
  }

  productDescriptionFactory($product) {
    return $(
      `<p class='pc-ComparisonForm-item-description'>${$product.productDescription}</p>`
    );
  }

  // Private: state management

  selectedProductIds() {
    return this.selectedProducts.map((obj) => obj.id);
  }

  addToSelectedProducts(id) {
    const $card = $(`.pc-ProductCard[data-style-id='${id}']`);
    this.selectedProducts.push({
      id: id,
      productDescription: $card.find('.pc-ProductCard-detailTitle').html(),
      productImgSrc: this.productImgSrc($card)
    });
    return ProductCatalog.LocalStorage.write(
      'product_comparision',
      this.selectedProducts
    );
  }

  removeFromSelectedProducts(id) {
    this.selectedProducts = this.selectedProducts.filter(
      (obj) => obj.id !== id
    );
    return ProductCatalog.LocalStorage.write(
      'product_comparision',
      this.selectedProducts
    );
  }

  productImgSrc($card) {
    let $productImg = $card.find('.pc-ProductCard-image img:visible');
    if (!$productImg.length) {
      $productImg = $card.find('.pc-ProductCard-image img').eq(0);
    }
    return $productImg.attr('src');
  }
}

jQuery(() => (ProductCatalog.ComparisonForm = new ComparisonForm()));
